import React, { useState, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Button,
  Space,
  message,
  DatePicker
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
// import commonFn from "@/utils/commonFn";

const ParamEditModal = forwardRef(({ record, paramEditModalSubmitlFn}, ref) => {
    const [form] = Form.useForm();
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    
    useImperativeHandle(ref, () => ({
      openModal: () => {
        setModalFlag(true)
      }
    }));

    useEffect(() => {
      if(modalFlag){
        console.log(record,'===record');
        form.setFieldsValue({
          expectedCompleteTimeStr: record?.['Completion Date'] && dayjs(record?.['Completion Date']) || null,
          contractDateStr: record?.['Contract Date'] && dayjs(record?.['Contract Date']) || null,
          commenceDateStr: record?.['Commence Date'] && dayjs(record?.['Commence Date']) || null,
          // contractedAmount: record?.['Original Contract Temp']
        })
      }
      return () => {
        setBtnLoading(false)
      }
    }, [modalFlag])

    const submitFn = async() => {
      setBtnLoading(true)
      const params = {
        id: record.id,
        expectedCompleteTimeStr: form.getFieldsValue()?.expectedCompleteTimeStr?.format('YYYY-MM-DD') || '',
        contractDateStr: form.getFieldsValue()?.contractDateStr?.format('YYYY-MM-DD') || '',
        commenceDateStr: form.getFieldsValue()?.commenceDateStr?.format('YYYY-MM-DD') || '',
      }
      const response = await http.post(api.updateContractDate, params);
      if(response.code === '1'){
        message.success("Successfully Update.");
        setModalFlag(false)
        paramEditModalSubmitlFn(params)
      }else{
        message.warning("Failed update.");
      }
      setBtnLoading(false)
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold"}}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {`Project Number: ${record?.['Project Number'] || ''}`}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      destroyOnClose={true}
      width="80%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
      >
        <Row gutter={[16, 16]}>
          <Col span={12} offset={6}>
            <Form.Item
              name="expectedCompleteTimeStr"
              label="Completion Date"
              rules={[{ required: true, message: 'Completion Date is required!' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={['MM/DD/YYYY', "M/D/YYYY"]}
              />
            </Form.Item>
            <Form.Item
              name="contractDateStr"
              label="Contract Date"
              rules={[{ required: true, message: 'Contract Date is required!' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={['MM/DD/YYYY', "M/D/YYYY"]}
              />
            </Form.Item>
            <Form.Item
              name="commenceDateStr"
              label="Commence Date"
              rules={[{ required: true, message: 'Commence Date is required!' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={['MM/DD/YYYY', "M/D/YYYY"]}
              />
            </Form.Item>
            {/* <commonFn.BtnAuthorityFn authKey={'contractedAmount'}>
             {commonFn.formInputNumberDoc({
                form,
                name: 'contractedAmount',
                label: "Original Contract",
                allowNegative: false
              })}
            </commonFn.BtnAuthorityFn> */}
          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => submitFn()} loading={btnLoading}>
            Submit
          </Button>
        </Space>
      </div>
    </Modal>
  );
});

export default ParamEditModal;